<div [hidden]="mostrandoTodos" *ngIf="tiposCliente.length > 0">
        <div *ngIf="tiposCliente.length > 0">
                <app-recomendador 
                        [esDental]="esDental"
                        [colectivaSenior]="colectivaSenior"
                        [tiposCliente]="tiposCliente" 
                        [tipoDocumento]="tipoDocumento"
                        [modoRecomendador]="modoRecomendador"
                        (colectivasChange)="onColectivasChange($event)"
                        (idOpcionPrimerNivelChange)="onIdOpcionPrimerNivelChange($event)"
                        (idOpcionInicialChange)="onIdOpcionInicialChange($event)"
                        (tipoClienteSeleccionadoChange)="onTipoClienteChange($event)"
                        (mostrarInfoSeniorYNormalChange)="onMostrarInfoSeniorYNormalChange($event)"
                        (datosRecomendadorPropuestaChange)="onDatosRecomendadorPropuestaChange($event)"></app-recomendador>
        </div>
</div>
<ca-card ui-3 *ngIf="!mostrandoTodos && agrupacionesPropuestas?.length > 0">
        <div ca-card-content>
                <div class="contenedor-propuestas">
                        <div *ngFor="let agrupacionPropuestas of agrupacionesPropuestas" class="col-12">
                                <h3>{{agrupacionPropuestas.nombreColectivaPadre}}</h3>
                                <div class="col-12 row ">
                                        <ng-container *ngFor="let propuestaColectiva of agrupacionPropuestas?.polizasColectivas; let last = last">
                                                <div class="col-4 tarjeta-propuesta">
                                                        <app-tarificacion-salud 
                                                                [propuesta]="propuestaColectiva?.polizaSalud"
                                                                [colectiva]="propuestaColectiva?.colectiva"
                                                                [propuestaDescuento]="propuestaColectiva?.polizaDescuento || null"
                                                                [colectivaDescuento]="propuestaColectiva?.colectivaDescuento || null"
                                                                [mostrarComparativoCoberturas]="mostrarComparativoCoberturas">
                                                        </app-tarificacion-salud>

                                                        <!-- Si el numero de tarjetas es multiplo de 3 lo mostramos debajo de la ultima -->
                                                        <div *ngIf="last && agrupacionPropuestas?.polizasColectivas.length % 3 === 0 ">
                                                                <ng-container *ngTemplateOutlet="plantillaInformacionTarificacion"></ng-container>
                                                        </div>
                                                </div>
                                                <div class="ml-4 col-4 tarjeta-propuesta" *ngIf="last && agrupacionPropuestas?.polizasColectivas.length % 3 !== 0">
                                                        <ng-container *ngTemplateOutlet="plantillaInformacionTarificacion"></ng-container>
                                                </div>
                                        </ng-container>
                                </div>
                        </div>
                </div>
        </div>
</ca-card>
<div *ngIf="mostrandoTodos && todosProductos?.length > 0 else noProductos">
        <ca-card ui-3 >
                <div ca-card-content>
                        <div class="contenedor-propuestas">
                                <div *ngFor="let agrupacion of todosProductos">
                                        <h3>{{ agrupacion.nombreColectivaPadre }}</h3>
                                        <div class="row">
                                                <div *ngFor="let propuesta of agrupacion.polizasColectivas"
                                                        class="col-4 tarjeta-propuesta">
                                                        <app-tarificacion-salud [propuesta]="propuesta.polizaSalud"
                                                                [colectiva]="propuesta.colectiva">
                                                        </app-tarificacion-salud>
                                                </div>
                                        </div>
                                </div>
                        </div>
                </div>
        </ca-card>
        <div class="row col-12 mt-4">
                <div class="float-left">
                        <button ca-button (click)="volverAlRecomendador()">
                                {{ 'MAIN.BOTON_VOLVER' | translate }}
                        </button>
                </div>
                <div class="float-right">
                        <button ca-button class="ca-btn-icon__container ml-2" type="button"
                                (click)="guardarProyecto()"
                                [disabled]="!agrupacionesPropuestas || agrupacionesPropuestas?.length === 0">
                                {{'MENU.PRIVADO.GUARDAR' | translate}}                        
                        </button>
                </div>  
        </div>
</div>
<ng-template #noProductos>
        <div class=" mt-4">
                <div class="float-left">
                        <button ca-button (click)="volverADatos()">
                                {{ 'MAIN.BOTON_VOLVER' | translate }}
                        </button>
                </div>
                <div class="float-right">
                        <button ca-button class="ca-btn-icon__container ml-2" type="button"
                                (click)="guardarProyecto()"
                                [disabled]="!agrupacionesPropuestas || agrupacionesPropuestas?.length === 0">
                                {{'MENU.PRIVADO.GUARDAR' | translate}}                        
                        </button>
                </div>  
        </div>

</ng-template>
<ng-template #plantillaInformacionTarificacion>
        <app-informacion-tarificacion
        [codCanal]="colectivasAgrupacion?.codCanal"
        [esDental]="esDental"
        [tipoCliente]="tipoClienteSeleccionado"
        [mostrarInfoSeniorYNormal]="mostrarInfoSeniorYNormal"
        (verTodosProductos)="onVerTodosProductos()"
        (verAlternativaSenior)="onVerAlternativaSenior()">
        </app-informacion-tarificacion>
</ng-template>